import { useMemo, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from '../../components/payment/CheckoutForm';


const Stripe = ({clientSecret, handleSubmit, publicKey}) => {
    const [ready, setReady] = useState(false);
    const stripePromise = useMemo(() => loadStripe(publicKey.trim()), [publicKey]);
    const options = { clientSecret };

    return (
        <Elements stripe={stripePromise} options={options}>
            {!ready && <p style={{ color: '#888' }}>Loading payment form...</p>}
            <div style={{ display: ready ? 'block' : 'none' }}>
                <CheckoutForm handleSubmitFinish={handleSubmit} onReady={() => setReady(true)} />
            </div>
        </Elements>
    )
};

export default Stripe;